import { Box, Paper } from "@mui/material";
import { colors } from "../../../../../../../ui/colors";
import { SkeletonBlock } from "@components/Skeleton";

export const SkeletonNumberCard = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                border: `1.5px solid ${colors.gray[100]}`,
                borderRadius: "14px",
                p: "16px 18px",
                position: "relative",
                overflow: "hidden",
                background: "var(--fx-surface-base, #FFFFFF)",
                boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <SkeletonBlock
                        width="58%"
                        height={24}
                        radius="8px"
                        sx={{ mb: 1 }}
                    />

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.75,
                            mb: 1.25,
                        }}
                    >
                        <SkeletonBlock variant="circle" width={14} height={14} />

                        <SkeletonBlock
                            width="42%"
                            height={14}
                            radius="6px"
                        />
                    </Box>

                    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                        <SkeletonBlock variant="pill" width={58} height={24} />
                        <SkeletonBlock variant="pill" width={58} height={24} />
                        <SkeletonBlock variant="pill" width={70} height={24} />
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: 106,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: 1,
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            gap: 0.5,
                        }}
                    >
                        <SkeletonBlock width={72} height={22} radius="7px" />
                        <SkeletonBlock width={42} height={12} radius="6px" />
                    </Box>

                    <SkeletonBlock width={104} height={36} radius="10px" />
                </Box>
            </Box>
        </Paper>
    );
};